/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {linkCopy} from '../api'

export const useMutationLinkCopy = createReactQueryMutationHook('linkCopy', linkCopy)
